
import * as React from "react";
import CountDownComp from "../global/CountDownComp";
import { ISetUrl } from "../../AppMain";
import { IActiveOrders } from "../../interfaces/IOrder";
import DateTool from "../../../avernus/datetool/source/DateTool";
import { Api } from "../../lib/Api";
import { Lng } from "../../../languages/Languages";
import Header from "../Header";

interface IOfferListTitleProps {
    category: Array<ICategory>
    title?: string
}

interface IOfferListTitleState {}


interface ICategory{
    name: string
    id:Number
    img: string
}

export default class OfferListTitle extends React.Component<IOfferListTitleProps, IOfferListTitleState>{

    constructor(props:IOfferListTitleProps){
        super(props);
        this.state = {
        };

    }


    render() {

        return (
            <div className = "offer_list_title">
                <img src = {this.props.category['img']} />
                <div className = "content">
                    <h1>{this.props.category['name']}</h1>
                    {this.props.title.length > 0 &&
                        <h2>{this.props.title}</h2>
                    }
                </div>
            </div>
        );
    }
}
